<div class="outerbox" [style.justify-self]="justifyself">
  <div class="compare-wrapper">
    <img #leftImg [src]="left" class="left-img" [attr.alt]="leftAlt || null" [attr.width]="width || null"
      [attr.height]="height || null" style="vertical-align: top !important;"  oncontextmenu="return false;" draggable="false">
    <div #divider class="divider"></div>
    <img #rightImg [src]="right" class="right-img" [attr.alt]="rightAlt || null" [attr.width]="width || null"
      [attr.height]="height || null" style="vertical-align: top !important;"  oncontextmenu="return false;" draggable="false">
  </div>
</div>
